<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card class="card" color="primary">
          <v-card-title> Licencias Oficiales Colectivas </v-card-title>
          <v-card-subtitle>
            Administre las Licencias Oficiales Colectivas a las que el personal se encuentra inscrito.
          </v-card-subtitle>
          <v-card-text>
            <v-tabs v-model="activeTab" color="secondary">
              <v-tab>LOCs</v-tab>
              <v-tab>Remesas</v-tab>
            </v-tabs>

            <v-tabs-items v-model="activeTab" class="transparent">
              <v-tab-item>
                <v-container>
                  <v-row>
                    <v-col cols="10">
                      <BaseSelect v-model="selectedLoc" :label="'Seleccione una Licencia'" :items="locOptions" />
                    </v-col>
                    <v-col cols="2">
                      <TextButton :loading="loading" :disabled="loading || !selectedLoc" @click="handleSavePersonalLoc">
                        Vincular
                      </TextButton>
                    </v-col>
                    <v-col cols="12">
                      <LocsPersonalTable :locs-personal="locsPersonal" />
                    </v-col>
                  </v-row>
                </v-container>
              </v-tab-item>
              <v-tab-item>
                <v-container>
                  <v-row>
                    <v-col cols="10">
                      <BaseSelect v-model="selectedRemesa" :label="'Seleccione una Remesa'" :items="remesasOptions" />
                    </v-col>
                    <v-col cols="2">
                      <TextButton
                        :loading="loading"
                        :disabled="loading || !selectedRemesa"
                        @click="handleSavePersonalRemesa"
                      >
                        Vincular
                      </TextButton>
                    </v-col>
                    <v-col cols="12">
                      <RemesasPersonalTable :remesas-personal="remesasPersonal" :remesas="remesas" />
                    </v-col>
                  </v-row>
                </v-container>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BaseSelect from '../../base/BaseSelect.vue'
import DateAdapter from '@/utils/DateAdapter'
import { API_DATE_FORMAT } from '@/const'
import TextButton from '@components/base/TextButton.vue'
import LocsPersonalTable from './LocsPersonalTable.vue'
import RemesasPersonalTable from './RemesasPersonalTable.vue'

export default {
  components: {
    BaseSelect,
    TextButton,
    LocsPersonalTable,
    RemesasPersonalTable,
  },

  props: {
    idPersonal: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      activeTab: 0,
      selectedLoc: null,
      selectedRemesa: null,
      loading: false,
    }
  },

  computed: {
    ...mapGetters('personalLoc', { locsPersonal: 'getPersonalLoc' }),
    ...mapGetters('licenciaOficialColectiva', { locs: 'getLocs' }),
    ...mapGetters('remesas', { remesas: 'getRemesas', remesasPersonal: 'getPersonalRemesas' }),

    locOptions() {
      return this.locs
        .map((loc) => ({
          title: `Licencia #${loc.noLicencia} - dada de alta el ${new DateAdapter(
            loc.fechaAlta,
            API_DATE_FORMAT
          ).toHumanReadable()}`,
          id: loc.idLoc,
        }))
        .filter((loc) => !this.locsPersonal.some(({ fk_idLoc }) => fk_idLoc === loc.id))
    },

    remesasOptions() {
      return this.remesas
        .map((remesa) => {
          const loc = this.locs.find((l) => l.idLoc === remesa.fk_idLoc)
          const numeroLicencia = loc?.noLicencia || 'N/A'

          return {
            title: `Remesa #${remesa.numOficio} - dada de alta el ${remesa.fechaAlta} - No. de LOC ${numeroLicencia}`,
            id: remesa.idRemesa,
          }
        })
        .filter((remesa) => !this.remesasPersonal.some(({ fk_idRemesa }) => fk_idRemesa === remesa.id))
    },
  },

  mounted() {
    this.fetchLocs()
    this.fetchPersonalLoc(this.idPersonal)
    this.fetchRemesas()
    this.fetchPersonalRemesas(this.idPersonal)
  },

  methods: {
    ...mapActions('personalLoc', ['fetchPersonalLoc', 'savePersonalLoc']),
    ...mapActions('licenciaOficialColectiva', ['fetchLocs']),
    ...mapActions('remesas', ['fetchRemesas', 'fetchPersonalRemesas', 'assignRemesaToPersonal']),

    async handleSavePersonalLoc() {
      this.loading = true
      await this.savePersonalLoc({ idPersonal: this.idPersonal, fk_idLoc: this.selectedLoc })
      await this.fetchPersonalLoc(this.idPersonal)
      this.selectedLoc = null
      this.loading = false
    },

    async handleSavePersonalRemesa() {
      this.loading = true
      await this.assignRemesaToPersonal({ idPersonal: this.idPersonal, idRemesa: this.selectedRemesa })
      this.selectedRemesa = null
      this.loading = false
    },
  },
}
</script>
